import Vue from 'vue';
import Vuex from 'vuex';
import ticket from './modules/ticket';
import www from './modules/www';
import cart from './modules/cart';
import overview from './modules/overview';
import map from './modules/map';
import { phoneHidden, localSave, localRead } from '@/setup/common';
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    isLogin: localStorage.getItem('isLogin') === 'true',
    loginPhone: localStorage.getItem('loginPhone'),
    locale: localRead('locale') || '',
    category: '',
  },
  mutations: {
    setCategory(state, item) {
      state.category = item;
    },
    setLocale(state, item) {
      state.locale = item;
      localSave('locale', item);
    },
    setIsLogin(state, flag) {
      state.isLogin = flag;
      localStorage.setItem('isLogin', flag);
    },
    setLoginPhone(state, flag) {
      state.loginPhone = phoneHidden(flag);
      localStorage.setItem('loginPhone', phoneHidden(flag));
    },
    // setLocale(state, val) {
    //   state.locale = val;
    // },
  },
  actions: {},
  modules: {
    ticket,
    www,
    overview,
    cart,
    map,
  },
});
